// UI global (menu desktop + footer accordion mobile)
// Extraido de main.js na Iter 16 porque main.js so carrega em template product (Iter 8),
// mas o header e o footer existem em todas as paginas.

(function() {
  function isMobile() {
    return window.innerWidth <= 750;
  }

  // Helpers de slide pra footer accordion mobile
  function slideDown(el, duration) {
    duration = duration || 300;
    el.style.removeProperty('display');
    let display = window.getComputedStyle(el).display;
    if (display === 'none') display = 'block';
    el.style.display = display;
    const height = el.offsetHeight;
    el.style.overflow = 'hidden';
    el.style.height = '0px';
    el.style.paddingTop = '0';
    el.style.paddingBottom = '0';
    el.style.marginTop = '0';
    el.style.marginBottom = '0';
    void el.offsetHeight;
    el.style.transitionProperty = 'height, margin, padding';
    el.style.transitionDuration = duration + 'ms';
    el.style.height = height + 'px';
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('margin-top');
    el.style.removeProperty('margin-bottom');
    setTimeout(() => {
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
    }, duration);
  }

  function slideUp(el, duration) {
    duration = duration || 300;
    el.style.transitionProperty = 'height, margin, padding';
    el.style.transitionDuration = duration + 'ms';
    el.style.boxSizing = 'border-box';
    el.style.height = el.offsetHeight + 'px';
    void el.offsetHeight;
    el.style.overflow = 'hidden';
    el.style.height = '0px';
    el.style.paddingTop = '0';
    el.style.paddingBottom = '0';
    el.style.marginTop = '0';
    el.style.marginBottom = '0';
    setTimeout(() => {
      el.style.display = 'none';
      el.style.removeProperty('height');
      el.style.removeProperty('padding-top');
      el.style.removeProperty('padding-bottom');
      el.style.removeProperty('margin-top');
      el.style.removeProperty('margin-bottom');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
    }, duration);
  }

  function slideToggle(el, duration) {
    if (window.getComputedStyle(el).display === 'none') slideDown(el, duration);
    else slideUp(el, duration);
  }

  function initFooterAccordion() {
    if (!isMobile()) return;
    document.querySelectorAll('.footer-block .footer-block__heading').forEach(heading => {
      heading.addEventListener('click', function(e) {
        e.preventDefault();
        const target = this.parentElement.querySelector('.footer-block__details-content');
        if (target) slideToggle(target);
      });
    });
  }

  function smoothScrollTo(top, duration) {
    duration = duration || 600;
    const start = window.scrollY;
    const change = top - start;
    const startTime = performance.now();
    function easeInOutQuad(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
    function step(now) {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, start + change * easeInOutQuad(progress));
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initBackToTop() {
    document.querySelectorAll('.btn-topo').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        smoothScrollTo(0, 600);
      });
    });
  }

  function initFilterDrawerAccordion() {
    document.querySelectorAll('.drawer-filter-mobile .filter-toggle').forEach(toggle => {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        this.classList.toggle('active');
        const target = this.parentElement.parentElement.querySelector('.drawer-filter-content');
        if (target) slideToggle(target);
      });
    });
  }

  function init() {
    // Footer accordion (mobile) — precisa rodar em TODAS as paginas
    initFooterAccordion();
    // Botão "voltar ao topo" (mobile) — precisa rodar em TODAS as paginas
    initBackToTop();
    // Acordeão dos filtros do drawer mobile (collection page) — precisa rodar em todas as paginas
    initFilterDrawerAccordion();

    if (isMobile()) return;

    // Hover nas categorias do menu superior — abre o <details> e exibe overlay
    document.querySelectorAll('.lower-menu .list-menu--inline li').forEach(li => {
      li.addEventListener('mouseenter', function() {
        const details = this.querySelector('details');
        if (details) details.setAttribute('open', 'true');
        const overlay = document.querySelector('.desktop-menu-overlay');
        if (overlay) overlay.classList.add('active');
      });
      li.addEventListener('mouseleave', function() {
        const details = this.querySelector('details');
        if (details) details.removeAttribute('open');

        const algumAberto = Array.from(document.querySelectorAll('.lower-menu details')).some(el => el.open);
        const megaMenu = document.querySelector('.desktop-categories-menu');
        const megaMenuAberto = megaMenu && megaMenu.classList.contains('active');

        if (!algumAberto && !megaMenuAberto) {
          const overlay = document.querySelector('.desktop-menu-overlay');
          if (overlay) overlay.classList.remove('active');
        }
      });
    });

    // Megamenu categorias (botao "Todas Categorias")
    const firstRoot = document.querySelector('.lower-menu .desktop-categories-menu .root-categories li:first-child');
    if (firstRoot) {
      const firstTarget = firstRoot.getAttribute('data-id');
      const firstLink = firstRoot.querySelector('a');
      if (firstLink) firstLink.classList.add('active');
      const firstChildren = document.querySelector(`.lower-menu .desktop-categories-menu .children-categories ul[data-id="${firstTarget}"]`);
      if (firstChildren) firstChildren.classList.add('active');
    }

    const catToggle = document.querySelector('#cat-menu-toggle');
    if (catToggle) {
      catToggle.addEventListener('click', function(e) {
        e.preventDefault();
        const menu = document.querySelector('.desktop-categories-menu');
        const overlay = document.querySelector('.desktop-menu-overlay');
        if (menu) menu.classList.toggle('active');
        if (overlay) overlay.classList.toggle('active');
      });
    }

    document.querySelectorAll('.desktop-menu-overlay').forEach(overlay => {
      overlay.addEventListener('click', function() {
        const menu = document.querySelector('.desktop-categories-menu');
        if (menu) menu.classList.remove('active');
        this.classList.remove('active');
      });
    });

    document.querySelectorAll('.lower-menu .desktop-categories-menu .root-categories li').forEach(li => {
      li.addEventListener('mouseenter', function() {
        const target = this.getAttribute('data-id');
        document.querySelectorAll('.lower-menu .desktop-categories-menu .root-categories li').forEach(x => x.classList.remove('active'));
        document.querySelectorAll('.lower-menu .desktop-categories-menu .children-categories ul').forEach(x => x.classList.remove('active'));
        this.classList.add('active');
        const targetUl = document.querySelector(`.lower-menu .desktop-categories-menu .children-categories ul[data-id="${target}"]`);
        if (targetUl) targetUl.classList.add('active');
      });
    });

    // Camadas de submenu (first-layer / second-layer)
    document.querySelectorAll('.first-layer-submenu').forEach(el => {
      el.addEventListener('mouseenter', function() {
        const target = this.getAttribute('data-target');
        const parentDetails = this.closest('details[id^="Details-HeaderMenu-"]');
        if (parentDetails) {
          parentDetails.querySelectorAll('.second-layer-submenu').forEach(x => x.classList.remove('active'));
        } else {
          document.querySelectorAll('.second-layer-submenu').forEach(x => x.classList.remove('active'));
        }
        if (target) {
          const scope = parentDetails || document;
          const targetEl = scope.querySelector(`.second-layer-submenu[data-target="${target}"]`);
          if (targetEl) targetEl.classList.add('active');
        }
      });
    });

    document.querySelectorAll('.second-layer-submenu').forEach(el => {
      el.addEventListener('mouseleave', function() {
        this.classList.remove('active');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
